import { useCurrentUser } from '@/hooks/useCurrentUser';

/**
 * Whether the reader may open the Organizations page.
 *
 * False until permissions have loaded: `CurrentUserProvider` starts `canAccessPartners` at
 * false and only sets it after two round trips, so a surface reading the flag alone treats
 * every reader as locked out on first paint. Folding the loading state in here means a
 * partner link is either absent or correct, never absent-then-wrong.
 */
export function usePartnerAccess(): boolean {
  const {
    permissionsLoading,
    currentUserPermissions: { canAccessPartners },
  } = useCurrentUser();
  return !permissionsLoading && canAccessPartners;
}
